export const registration = {
    methods : {
        moneyFormat : function (v) {
            if (!v) {
                v = 0;
            }
            var n = parseFloat(v);
            return n.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
        },
    },
    data : function () {
        return {
            gbs    : [500, 1000, 2000, 3000, 4000, 5000],
            years : [1, 5, 10, 15, 20, 25, 30, 35, 40],
            prices : [
                [9.99, 19.99, 28.99, 37.99, 36.99, 45.99, 54.99, 63.99, 64.99],
                [19.99, 29.99, 38.99, 47.99, 46.99, 55.99, 64.99, 73.99, 84.99],
                [28.99, 38.99, 47.99, 56.99, 55.99, 64.99, 73.99, 82.99, 102.99],
                [37.99, 47.99, 56.99, 65.99, 64.99, 73.99, 82.99, 91.99, 116.99],
                [46.99, 56.99, 65.99, 74.99, 73.99, 82.99, 91.99, 99.99, 133.99],
                [55.99, 65.99, 74.99, 83.99, 82.99, 91.99, 99.99, 108.99, 149.99]
            ]
        };
    },
    computed : {
        showTime : function () {
            return this.time + ' Years';
        },
        showSpace : function () {
            if (this.space == 500) {
                return '500MB';
            }
            var gb = this.space / 1000;
            return gb + 'GB';
        },
        showSpaceHelper : function () {
            var image = _.ceil(this.space / 3.5),           // jpg is approx             3.5MB per photo
                audio = _.ceil(this.space / 2),             // mp3 is approx             2.0MB per minute
                video = _.ceil(this.space / (3.5 * 60)),    // Video is approx           3.5MB per second
                hd    = _.ceil(this.space / (8 * 60));      // HD video (720p) is approx 8.0MB per second
            return `Approximately ${image} photos, or ${audio} minutes of audio, or ${video} minutes of video (${hd} minutes in HD).`;
        },
        pennies : function () {
            return this.price * 100;
        },
        price : function () {
            let space     = this.space,
                space_idx = 0,//_.findIndex(this.gbs, this.space),
                time      = this.time,
                time_idx  = 0;//_.findIndex(this.years, this.time);
            _.each(this.gbs, function (gb, i) {
                if (gb == space) {
                    space_idx = i;
                }
            })
            _.each(this.years, function (yr, i) {
                if (yr == time) {
                    time_idx = i;
                }
            })
            return this.prices[space_idx][time_idx];


            // var fixed     = 4,                       // initial costing - this should give them some profit...
            //     transfers = 0.09,
            //     year_cost = _.ceil(0.0025 * 12, 1),  // hosting cost per GB per year
            //     gb        = this.space / 1000;       // space required in GB

            // // adjust the fixed cost for economies of scale - the lower the storage, the more it should cost
            // if (gb <= 1) {
            //     fixed = fixed + 1.25;
            // } else if (gb < 3) {
            //     fixed = fixed + 1;
            // }

            // // adjust the fixed costs for inflation - add an extra pound (or so) for every 15 years
            // fixed = fixed + _.ceil(this.time / 15, 1);

            // // Assume that every GB will be watched/downloaded 10 times by 10 individuals over
            // // the lifetime of the service.
            // // @todo - adjust this for the lifetime of the project
            // var transfer_num = 100;
            // var gb_cost = (transfers * transfer_num); // cost of data transfer - price per GB, plus upload, 10 viewers watching 10 times

            // // the transfer cost per GB is the expensive/unknown part.
            // // how often will they watch?  How many people will watch?  Will it
            // // be cached locally?
            // var transfer = _.ceil(gb_cost * gb, 1);         // round up to nearest 10p;

            // // price for this amount of storage per year
            // var annual   = _.ceil((year_cost * gb), 2);     // round up to nearest 1p
            // // total price for this amount of storage for this amount of time
            // var total    = _.ceil((this.time * annual), 2); // round up to nearest 1p

            // // total price - fixed costs, plus transfer price, plus storage price
            // var price = _.ceil(fixed + transfer + total, 1);
            // return price;
            // // console.debug(`
            // // Storage : ${gb}GB
            // // Fixed costs : ${this.moneyFormat(fixed)}
            // // Transfer costs : ${this.moneyFormat(transfer)}
            // // Annual costs : ${this.moneyFormat(annual)}
            // // Annual costs over ${this.time} years : ${this.moneyFormat(total)}
            // // Total : ${this.moneyFormat(price)}`);
        }
    }
}